module.exports = __webpack_public_path__ + "img/Beerscovery_Logo_MagnifyGlass_White.046e594f.png";